export default "__VITE_ASSET__QVGUCuWA__"